// These are all valid email addresses - Which we mark as valid
// 9xyz@example.com
// a+xyz@example.com
// abc+@example.com
// abc+@example.co.in
// abc@example.academy

// We enforce
// 1. alphanumeric domain part
// 2. alphanumeric username part, can contain periods, underscores, plus signs, and hyphens
// 3. domain part can be .com, .co.in, .academy (new tlds can be large words, .academy is a real tld)
// 4. We do no allow unicode in the username part yet

const emailRegex = /^[a-z0-9._\+-]*@[a-z0-9]+\.[a-z.]{2,}$/i;

angular.module('capability-ng-global').constant('emailRegex', emailRegex);



// WEBPACK FOOTER //
// ./app/lib/global/patterns/email_regex.ts